module.exports = __webpack_public_path__ + "static/media/bonariv-section-2.8b63847e.png";